// The registration details a patient must have before an imported patient can be confirmed, or a patient the import
// couldn't create can be registered for its records. Keep in step with PatientImportService.getMissingFields in
// CatTraxServices, which refuses either without them.
app.service("PatientRequiredDetails", [
	"countryConfig",
	function (countryConfig) {
		// In the order the details form shows them.
		const FIELDS = [
			{ label: "Address", nzOnly: true, missing: (p, form) => !(form ? form.hasLookedUpAddress() : hasLookedUpPhysicalAddress(p)) },
			{ label: "Gender", nzOnly: true, missing: (p) => !p.gender },
			{ label: "Interpreter needed", nzOnly: true, missing: (p) => !isAnswered(p.isInterpreterNeeded) },
			{
				label: "Interpreter language",
				nzOnly: true,
				missing: (p) => p.isInterpreterNeeded === true && isBlank(p.interpreterLanguage),
			},
			{ label: "Resident", nzOnly: true, missing: (p) => !isAnswered(p.isResident) },
			{ label: "Ethnicity", nzOnly: true, missing: (p) => !hasEthnicity(p) },
			{ label: "Mobile or phone number", missing: (p) => isBlank(p.mobileNumber) && isBlank(p.phoneNumber) },
		];

		function isBlank(value) {
			return !value || !String(value).trim();
		}

		function isAnswered(value) {
			return value === true || value === false;
		}

		// A physical address picked from the lookup: its coordinates are how the DHB is found.
		function hasLookedUpPhysicalAddress(p) {
			const address = (p.addresses || []).find((a) => a.type === "PHYSICAL");
			if (!address || !address.json) {
				return false;
			}
			try {
				const location = (JSON.parse(address.json).geometry || {}).location;
				return !!location && typeof location.lat === "number" && typeof location.lng === "number";
			} catch (e) {
				return false;
			}
		}

		// The coded ethnicities the form picks, or the older list an import may have written.
		function hasEthnicity(p) {
			return (p.codedEthnicities || []).length > 0 || (p.ethnicities || []).length > 0 || !isBlank(p.otherEthnicities);
		}

		return {
			// The labels of the details the patient is missing. form: the details form's API (see patientDetailsForm)
			// while it is up, so the address is judged by what is in its field rather than what was last saved.
			missing: function (patient, form) {
				const nz = countryConfig.countryCode !== "AU";
				return FIELDS.filter((field) => (nz || !field.nzOnly) && field.missing(patient, form)).map((field) => field.label);
			},
		};
	},
]);
